<div class="avatar" #avatar></div>
<cm-icon *ngIf="canUseColoredPlaceholder" [name]="iconName" class="user-icon"></cm-icon>
